module.exports = __webpack_public_path__ + "static/img/200125.f114da93.png";